import {http} from '@/http'
import {Storage} from '../../../core/Utils'

const resource = "/api";

export default {
  loadQuestionsAndCompetencies() {
    return http.get(`${resource}/Question`)
      .then(response => {
        Storage.setQuestions(response.questions);
        Storage.setCompetencies(response.competencies);
        return response
      }
    );
  },
  getLastScore() {
    return http.get(`${resource}/Question/get-last-score`)
  },
}
